import * as THREE from 'three'
import Experience from '../Experience.js'
import EventEmitter from './EventEmitter.js'

export default class Selector extends EventEmitter
{
    constructor()
    {
        super()
        this.experience = new Experience();
        this.input = this.experience.input;
        this.camera = this.experience.camera;
        this.scene = this.experience.scene;
        this.world = this.experience.world;
        this.ui = this.experience.ui;
        this.raycaster = new THREE.Raycaster();
        this.currentIntersect = null;
        this.intersects = null;       
        
    }

    getIndex()
    {
        //console.log(this.tapType)
        return this.tapType;
    }
    pointerUp()
    {
        //console.log(this.curIndex)
        if(this.currentIntersect && this.ui.mode == 0 && this.ui.completeIntro)    
        {
            //console.log("name ".concat(this.currentIntersect.object.name))        
            switch(this.currentIntersect.object.name)  
            {
                case "Isla_InstAerea":
                case"Isla_InstAereav2":
                case "Insla_InstaAerea":
                    this.experience.curIndex = 0;
                break; 
                case "Isla_InstaSub":
                case "Isla_InstSubv2":
                    this.experience.curIndex = 1;
                break;
                case "Isla_InstUMilla":
                case "Isla_InstUMillav2":
                    this.experience.curIndex = 2;
                break;
                case "Isla_InstCDatos":
                case "Isla_InstCDatosv2":
                    this.experience.curIndex = 3;
                break;
                case "Isla_InstCEstruc":
                case "Isla_InstCEstrucv2":
                    this.experience.curIndex = 4;
                break;
                case "Isla_FIB2Uv2":
                    this.experience.curIndex = 5;
                break;
                case "acopladores":
                case "cables_exteriores":
                case "cables_preconectorizados":
                case "cierres_empalme":
                case "conectores_mecanicos":
                case "consumibles":
                case "divisores_opticos":
                case "herramientaskits_fusion_medicion_limpieza":
                case "identificacion":
                case "remates_herrajes":
                    //console.log(this.currentIntersect.object.position)
                break;
                /*default:
                    console.log(this.currentIntersect.object.name)
                    break;*/
            }
            //console.log(this.experience.tapType)
            //console.log(this.experience.curIndex)
            if(this.experience.curIndex != this.experience.tapType)// && this.experience.curIndex>=0)
            {
                this.currentIntersect.object.getWorldPosition(this.experience.targetPos);
                this.experience.tapType = this.experience.curIndex;
                //console.log("new")
                //Animate Camera and Draw Info
                this.poISelected();
            }
        }
    }
    update()
    {
        
        this.raycaster.setFromCamera(this.input.mouse, this.camera.instance);
        this.intersects = this.raycaster.intersectObjects(this.scene.children, true)
        if(this.intersects.length)        
            this.currentIntersect = this.intersects[0];        
        else                
            this.currentIntersect = null;    
    
    }

    poISelected()
    {
        this.trigger('poISelected');
    }
}